"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideSearchBar = exports.showSearchBar = void 0;
var logoHandler_1 = __importDefault(require("./logoHandler"));
var SearchBarAction = document.querySelector('[data-js-action="Header.SearchBar"]');
var SearchBarTarget = document.querySelector('[data-js-target="Header.SearchBar"]');
var SearchBarInput = document.querySelector('.SearchBar__input');
var header = document.querySelector('.Header');
var _a = (function () {
    var func = function (e) {
        var target = e.target;
        var partOfSearchBar = target.closest('.SearchBar') !== null;
        var partOfSearchIcon = target.closest('.HeaderMainNav__searchIcon') !== null;
        if (!partOfSearchBar && !partOfSearchIcon) {
            exports.hideSearchBar();
        }
    };
    return [
        function () { return document.addEventListener('click', func); },
        function () { return document.removeEventListener('click', func); }
    ];
})(), addGlobalCloseEvent = _a[0], cleanupGlobalCloseEvent = _a[1];
var showSearchBar = function () {
    var shrinkLogo = header.classList.contains('is-top')
        && document.body.classList.contains('home')
        && window.innerWidth > 1220;
    SearchBarTarget.classList.remove('is-hidden');
    SearchBarInput.focus();
    addGlobalCloseEvent();
    if (shrinkLogo) {
        logoHandler_1.default('shrink');
    }
    return true;
};
exports.showSearchBar = showSearchBar;
var hideSearchBar = function () {
    logoHandler_1.default('');
    SearchBarTarget.classList.add('is-hidden');
    SearchBarAction.blur();
    cleanupGlobalCloseEvent();
};
exports.hideSearchBar = hideSearchBar;
exports.default = (function () {
    if (!SearchBarAction) {
        return false;
    }
    SearchBarAction.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return (SearchBarTarget.classList.contains('is-hidden') ?
            exports.showSearchBar() :
            exports.hideSearchBar());
    });
    return true;
});
